module.exports = __webpack_public_path__ + "img/logo.81905771.jpeg";